import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29d1c5d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "restore-account px-10 mb-20" }
const _hoisted_2 = {
  key: 0,
  class: "restore-account__wrapper text-center pa-40"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mb-20" }, "Восстановление пароля", -1))
const _hoisted_4 = {
  key: 0,
  class: "text-gradient d-inline-flex flex-direction-column"
}
const _hoisted_5 = { class: "text-center mb-10" }
const _hoisted_6 = {
  key: 1,
  class: "restore-account__wrapper text-center pa-40"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mb-10" }, [
  /*#__PURE__*/_createTextVNode("Мы отправили код"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" на почту")
], -1))
const _hoisted_8 = { class: "text-gradient text-center mb-20 d-inline-flex" }
const _hoisted_9 = { class: "restore-account__form" }
const _hoisted_10 = { class: "text-gradient d-inline-flex flex-direction-column" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-center mb-10" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Повторно отправить через"),
  /*#__PURE__*/_createTextVNode(" 30 секунд")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Хотите создать новый аккаунт?")
], -1))
const _hoisted_14 = {
  key: 2,
  class: "restore-account__wrapper text-center pa-40"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mb-10" }, "Новый пароль", -1))
const _hoisted_16 = { class: "text-gradient text-center mb-20 d-inline-flex" }
const _hoisted_17 = { class: "restore-account__form" }

import BaseInput from '@/components/Inputs/BaseInput.vue'
import BaseButton from '@/components/Buttons/BaseButton.vue'
import BackLine from '@/components/Lines/BackLine.vue'
import { ref } from 'vue'
import CircleButton from '@/components/Buttons/CircleButton.vue'
import router from '@/router'
import { useAuthStore } from '@/stores/auth'
import { restore } from '@/helpers/auth'
import { IValidateForm, Validate } from '@/helpers/validate'


export default /*#__PURE__*/_defineComponent({
  __name: 'RestoreView',
  setup(__props) {


const step = ref(1)
const login = ref<string>('')
const code = ref('')
const password = ref('')
const errors = ref<any>({})
const isLoading = ref<boolean>(false)
const currentField = ref<string>('')

const authStore = useAuthStore()
const setStep = (stepValue: number): void => {
  step.value = stepValue
}
const setLoading = (status: boolean) => {
  isLoading.value = status
}
const inFocus = (input: string) => {
  currentField.value = input
  errors.value = {}
}
const outFocus = (
  input: string,
  // ESLINT-ERROR: Старая реализация
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  model: any,
  title: string,
  rules: string[]
) => {
  currentField.value = ''
  errors.value = Validate([
    {
      name: input,
      rules: rules as IValidateForm['rules'],
      value: model,
      ru: title
    }
  ])
}
const onSubmit = async () => {
  setLoading(true)
  const validate = Validate([
    {
      name: 'login',
      rules: ['required'],
      value: login.value,
      ru: 'Ник / Почту'
    }
  ])
  console.log(validate)
  errors.value = {}
  if (Object.keys(validate).length) {
    errors.value = validate
    setLoading(false)
  } else {
    const result = await restore(login.value).finally(() => setLoading(false))
    if (result.isSend) {
      await router.push('/login/restore-success')
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BackLine, null, {
      default: _withCtx(() => [
        (step.value === 1)
          ? (_openBlock(), _createBlock(CircleButton, {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).go(-1))),
              name: "chevron-left-gradient",
              bg: "empty",
              iconWidth: 21,
              iconHeight: 16,
              "view-box": "0 0 21 16"
            }))
          : _createCommentVNode("", true),
        (step.value > 1)
          ? (_openBlock(), _createBlock(CircleButton, {
              key: 1,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (setStep(step.value - 1))),
              name: "chevron-left-gradient",
              bg: "empty",
              iconWidth: 21,
              iconHeight: 16,
              "view-box": "0 0 21 16"
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      (step.value === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("form", {
              onSubmit: _withModifiers(onSubmit, ["prevent"]),
              class: "restore-account__form",
              enctype: "multipart/form-data"
            }, [
              _createVNode(BaseInput, {
                onFocusin: _cache[2] || (_cache[2] = ($event: any) => (inFocus('login'))),
                onFocusout: _cache[3] || (_cache[3] = ($event: any) => (outFocus('login', login.value, 'Ник / Почту', ['required']))),
                modelValue: login.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((login).value = $event)),
                type: "text",
                class: "mb-10 full-width",
                placeholder: "Ник / Почта"
              }, null, 8, ["modelValue"]),
              _createVNode(BaseButton, {
                disabled: isLoading.value || !!Object.keys(errors.value).length,
                class: "large rounded margin-auto mb-20 full-width",
                bg: "gradient",
                border: "gradient"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Далее")
                ]),
                _: 1
              }, 8, ["disabled"])
            ], 32),
            (errors.value.login)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("h6", _hoisted_5, _toDisplayString(errors.value.login[0]), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (step.value === 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("h5", _hoisted_8, _toDisplayString(login.value), 1),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(BaseInput, {
                modelValue: code.value,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((code).value = $event)),
                class: "mb-10 full-width",
                type: "text",
                placeholder: "Код"
              }, null, 8, ["modelValue"]),
              _createVNode(BaseButton, {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (setStep(3))),
                class: "large rounded margin-auto mb-20 full-width",
                bg: "gradient",
                border: "gradient"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Далее")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _hoisted_12,
              _hoisted_13,
              _createElementVNode("h5", null, [
                _createVNode(_component_router_link, { to: {name: 'login-register'} }, {
                  default: _withCtx(() => [
                    _createTextVNode("Зарегистрироваться")
                  ]),
                  _: 1
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (step.value === 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("h5", _hoisted_16, _toDisplayString(login.value), 1),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(BaseInput, {
                modelValue: password.value,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((password).value = $event)),
                class: "mb-10 full-width",
                type: "password",
                placeholder: "Пароль"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_router_link, { to: {name: 'login-restore-success'} }, {
                default: _withCtx(() => [
                  _createVNode(BaseButton, {
                    class: "large rounded margin-auto mb-20 full-width",
                    bg: "gradient",
                    border: "gradient"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("подтвердить")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})